//数据
//分支锁号
export { lockArea,materialMeau,materialItem,provinceArr }
const lockArea=[
            {
                "name":"贵州分公司(Z)",
                "value":"Z"
            },{
                "name":"济南分公司(X)",
                "value":"X"
            },{
                "name":"湖南分公司(T)",
                "value":"T"
            },{
                "name":"甘肃分公司(S)",
                "value":"S"
            },{
                "name":"南京分公司(R)",
                "value":"R"
            },{
                "name":"郑州分公司(Q)",
                "value":"Q"
            },{
                "name":"山西分公司(P)",
                "value":"P"
            },{
                "name":"安徽分公司(O)",
                "value":"O"
            },{
                "name":"哈尔滨分公司(N)",
                "value":"N"
            },{
                "name":"长春分公司(M)",
                "value":"M"
            },{
                "name":"沈阳分公司(L)",
                "value":"L"
            },{
                "name":"广州分公司(J)",
                "value":"J"
            },{
                "name":"广西分公司(I)",
                "value":"I"
            },{
                "name":"云南分公司(H)",
                "value":"H"
            },{
                "name":"石家庄分公司(G)",
                "value":"G"
            },{
                "name":"新疆分公司(F)",
                "value":"F"
            },{
                "name":"陕西分公司(E)",
                "value":"E"
            },{
                "name":"重庆分公司(D)",
                "value":"D"
            },{
                "name":"天津分公司(C)",
                "value":"C"
            },{
                "name":"苏州分公司(BR)",
                "value":"BR"
            },{
                "name":"青岛分公司(BQ)",
                "value":"BQ"
            },{
                "name":"厦门分公司(AJ)",
                "value":"AJ"
            },{
                "name":"福建分公司(AI)",
                "value":"AI"
            },{
                "name":"成都分公司(AH)",
                "value":"AH"
            },{
                "name":"深圳分公司(AE)",
                "value":"AE"
            },{
                "name":"擎洲分公司(U)",
                "value":"U"
            },{
                "name":"宁夏分公司(AD)",
                "value":"AD"
            },{
                "name":"北京分公司(A)",
                "value":"A"
            },{
                "name":"内蒙古分公司(AG)",
                "value":"AG"
            },{
                "name":"上海分公司(B)",
                "value":"B"
            },{
                "name":"青海分公司(K)",
                "value":"K"
            },{
                "name":"海南分公司(W)",
                "value":"W"
            },{
                "name":"江西分公司(V)",
                "value":"V"
            },{
                "name":"湖北分公司(Y)",
                "value":"Y"
            },{
                "name":"西藏分公司(XZ)",
                "value":"XZ"
            }];
// 我的订阅
// 左侧类别
const materialMeau=[
    {"name":"钢材","imgName":"light"},
    {"name":"管材","imgName":"dark"},
    {"name":"钢板","imgName":"dark"},
    {"name":"地材","imgName":"dark"},
    {"name":"安装","imgName":"dark"},
]
// 右侧具体材料
const materialItem=[
    {"name":"钢材","imgName":"light","children":[
        {"name":"H型钢","parentName":"钢材"},{"name":"三级螺纹钢","parentName":"钢材"},
        {"name":"四级盘螺","parentName":"钢材"},{"name":"四级螺纹钢","parentName":"钢材"},
        {"name":"圆钢","parentName":"钢材"},{"name":"工字钢","parentName":"钢材"},
        {"name":"扁钢","parentName":"钢材"},{"name":"槽钢","parentName":"钢材"},
        {"name":"热镀扁钢","parentName":"钢材"},{"name":"角钢","parentName":"钢材"},
        {"name":"高线","parentName":"钢材"},
    ]},
    {"name":"管材","imgName":"dark","children":[
        {"name":"方管","parentName":"管材"},{"name":"无缝管","parentName":"管材"},
        {"name":"架子管","parentName":"管材"},{"name":"焊管","parentName":"管材"},
        {"name":"矩管","parentName":"管材"},{"name":"螺旋管","parentName":"管材"},
        {"name":"镀锌管","parentName":"管材"},
    ]},
    {"name":"钢板","imgName":"dark","children":[
        {"name":"中厚板","parentName":"钢板"},{"name":"不锈钢卷","parentName":"钢板"},
        {"name":"不锈钢板","parentName":"钢板"},{"name":"冷轧板","parentName":"钢板"},
        {"name":"彩涂卷","parentName":"钢板"},{"name":"彩涂板","parentName":"钢板"},
        {"name":"热轧卷","parentName":"钢板"},{"name":"热轧板","parentName":"钢板"},
        {"name":"镀锌板","parentName":"钢板"},{"name":"高强板","parentName":"钢板"},
    ]},
    {"name":"地材","imgName":"dark","children":[
        {"name":"混凝土","parentName":"地材"},{"name":"水泥","parentName":"地材"},
    ]},
    {"name":"安装","imgName":"dark","children":[
        {"name":"低压电缆YJV","parentName":"安装"},{"name":"中压电缆YJV","parentName":"安装"},
        {"name":"布线电缆BV","parentName":"安装"},
    ]},
]
 // 省  没有香港 澳门
 const provinceArr=[
    {"name":"重庆","code":""},
    {"name":"北京","code":""},
    {"name":"上海","code":""},
    {"name":"天津","code":""},
    {"name":"河北","code":""},
    {"name":"山东","code":""},
    {"name":"辽宁","code":""},
    {"name":"黑龙江","code":""},
    {"name":"甘肃","code":""},
    {"name":"吉林","code":""},
    {"name":"青海","code":""},
    {"name":"河南","code":""},
    {"name":"江苏","code":""},
    {"name":"湖北","code":""},
    {"name":"湖南","code":""},
    {"name":"浙江","code":""},
    {"name":"江西","code":""},
    {"name":"广东","code":""},
    {"name":"云南","code":""},
    {"name":"福建","code":""},
    {"name":"台湾","code":""},
    {"name":"海南","code":""},
    {"name":"山西","code":""},
    {"name":"四川","code":""},
    {"name":"陕西","code":""},
    {"name":"贵州","code":""},
    {"name":"安徽","code":""},
    {"name":"广西","code":""},
    {"name":"内蒙古","code":""},
    {"name":"西藏","code":""},
    {"name":"新疆","code":""},
    {"name":"宁夏","code":""},
]